import { AnnouncementTarget, AnnouncementType } from '../enums';

export interface ICreateAnnouncementDto {
    title: string;
    /** Plain text. */
    message: string;
    type: AnnouncementType;
    /** Defaults to `AnnouncementTarget.User`. */
    target?: AnnouncementTarget;
    /** Empty means every organization. */
    organizationIds: string[];
    /** ISO date, UTC. */
    startsAt: string;
    /** ISO date, UTC. Must be after `startsAt`. */
    endsAt: string;
    /** See `AnnouncementFrequency`. `0` = every visit, `-1` = only once. */
    frequencyMinutes: number;
    active?: boolean;
}

export type IUpdateAnnouncementDto = Partial<ICreateAnnouncementDto>;

/** What the ABM sees. Per-user maps (`discardedAt`, `viewedBy`) are never exposed. */
export interface IAnnouncementOutputDto {
    id: string;
    title: string;
    message: string;
    type: AnnouncementType;
    target: AnnouncementTarget;
    organizationIds: string[];
    startsAt: string;
    endsAt: string;
    frequencyMinutes: number;
    active: boolean;
    viewsCount: number;
    createdBy?: string;
    updatedBy?: string;
    createdAt?: string;
    updatedAt?: string;
}

/** What the top bar of a regular user receives. */
export type IActiveAnnouncementDto = Pick<
    IAnnouncementOutputDto,
    'id' | 'title' | 'message' | 'type' | 'startsAt' | 'endsAt'
>;
